"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnInsertDetector = void 0;
const calculateColumnsOffsets_1 = require("./calculateColumnsOffsets");
const getColumnIndexByCursorPosition_1 = require("./getColumnIndexByCursorPosition");
class ColumnInsertDetector {
    constructor() {
        //scrollLeftOffset
        this.nextColumnIndex = 0;
        this.prevColumnIndex = 0;
        // private startClientX = 0;
        this.rootLeftOffset = 0;
        this.scrollLeftOffset = 0;
        this.columnsWidths = [];
        this.columnsOffsets = [];
    }
    //scrollLeftOffset
    start({ rootHTMLElement, bodyHtmlElement, columnsWidths, currentClientX }) {
        var _a, _b;
        this.nextColumnIndex = 0;
        this.prevColumnIndex = 0;
        // this.startClientX = currentClientX;
        this.columnsWidths = columnsWidths;
        const rootBoundingClientRect = rootHTMLElement === null || rootHTMLElement === void 0 ? void 0 : rootHTMLElement.getBoundingClientRect();
        this.rootLeftOffset = (_a = rootBoundingClientRect === null || rootBoundingClientRect === void 0 ? void 0 : rootBoundingClientRect.left) !== null && _a !== void 0 ? _a : 0;
        this.scrollLeftOffset = (_b = ((bodyHtmlElement === null || bodyHtmlElement === void 0 ? void 0 : bodyHtmlElement.scrollLeft) || 0)) !== null && _b !== void 0 ? _b : 0;
        const { columnsOffsets, edgeColumnOffset, startIndexLimit, endIndexLimit } = (0, calculateColumnsOffsets_1.calculateColumnsOffsets)({
            columns: columnsWidths
        });
        this.columnsOffsets = columnsOffsets;
        const currentColumnIndex = (0, getColumnIndexByCursorPosition_1.getColumnIndexByCursorPosition)({
            columnsOffsets,
            edgeColumnOffset,
            cursorLeftOffset: currentClientX - this.rootLeftOffset + this.scrollLeftOffset,
            startIndexLimit,
            endIndexLimit
        });
        this.nextColumnIndex = currentColumnIndex;
        this.prevColumnIndex = currentColumnIndex;
    }
    stop() {
        this.prevColumnIndex = 0;
        this.nextColumnIndex = 0;
        this.columnsOffsets = [];
    }
    capture({ currentClientX }) {
        const { columnsOffsets, edgeColumnOffset, startIndexLimit, endIndexLimit } = (0, calculateColumnsOffsets_1.calculateColumnsOffsets)({
            columns: this.columnsWidths
        });
        this.columnsOffsets = columnsOffsets;
        this.nextColumnIndex = (0, getColumnIndexByCursorPosition_1.getColumnIndexByCursorPosition)({
            columnsOffsets,
            edgeColumnOffset,
            cursorLeftOffset: currentClientX - this.rootLeftOffset + this.scrollLeftOffset,
            currentIndex: this.prevColumnIndex,
            startIndexLimit,
            endIndexLimit
        });
    }
    getValue() {
        const isRightDirectionMoving = this.nextColumnIndex > this.prevColumnIndex;
        return {
            columnIndexChanged: this.prevColumnIndex !== this.nextColumnIndex,
            prevColumnIndex: this.prevColumnIndex,
            nextColumnIndex: this.nextColumnIndex,
            direction: isRightDirectionMoving ? 1 : 0,
            insertPositionOffset: isRightDirectionMoving
                ? this.columnsOffsets[this.nextColumnIndex].rightOffset - this.scrollLeftOffset
                : this.columnsOffsets[this.nextColumnIndex].leftOffset - this.scrollLeftOffset
        };
    }
}
exports.ColumnInsertDetector = ColumnInsertDetector;
//# sourceMappingURL=ColumnInsertDetector.js.map